import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

import { RouteUrls } from 'routes/RouteConstants';

const BackToMap = () => {
    return (
        <Link
            to={RouteUrls.SEARCH}
            style={{
                textDecoration: 'underline',
                display: 'inline-block',
            }}
        >
            <i
                className="fa-solid fa-arrow-circle-left"
                style={{ marginRight: 5 }}
            />
            Back to Map
        </Link>
    );
};

export default BackToMap;
